<template>
  <div
    class="page-banner d-flex flex-column justify-content-center position-relative"
  >
    <!-- <div class="mask" :style="'background: linear-gradient(102.65deg, '+ bannerData.colorGroup[0] +' 8.39%, '+ bannerData.colorGroup[1] +' 90.33%);'"></div> -->
    <div class="Carousel">
      <el-carousel class="d-none d-sm-block" height="46.8vw" motion-blur>
        <el-carousel-item v-for="item in bannerData.bgImgSrc" :key="item">
          <img :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
      <el-carousel class="d-block d-sm-none" height="177.9vw" motion-blur>
        <el-carousel-item v-for="item in bannerData.bgImgSmSrc" :key="item">
          <img :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="basic-type w-100 h-100 d-flex">
      <div class="contentBox">
        <div class="main-title">{{ bannerData.title }}</div>
        <div class="sub-title">{{ bannerData.subTitle }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    bannerData: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
          alias: "",
          bgImgSrc: [],
          bgImgSmSrc: "",
          colorGroup: []
        }
      },
    }
  },
  data() {
    return {
      imgSrc: ""
    }
  },
  beforeMount() {
    if(window.innerWidth < 768.9) {
        this.imgSrc = this.bannerData.bgImgSmSrc
    } else {
        this.imgSrc = this.bannerData.bgImgSrc
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth < 768.9) {
          this.imgSrc = this.bannerData.bgImgSmSrc
      } else {
          this.imgSrc = this.bannerData.bgImgSrc
      }
    })
  }
};
</script>

<style lang="scss">
.page-banner {
  position: relative;
  overflow: hidden;
  height: 46.8vw;
  letter-spacing: 6px;
  z-index: 1;
  background-color: black;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: $sm) {
    height: calc(177.9vw * 0.8);
  }
  .logo {
    width: 300px;
    z-index: 0;
  }
  .mask {
    position: absolute;
    width: 100%;
    min-height: 100%;
    z-index: 0;
    opacity: 0.2;
  }
  .Carousel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    img {
      object-fit: contain;
      object-position: top;
      width: 100%;
      height: 100%;
      @media (max-width: $md) {
        object-fit: cover;
      }
    }
  }
  .basic-type {
    align-items: center;
    @media (max-width: $sm) {
      align-items: start;
      justify-content: center;
    }
  }
  .contentBox {
    color: white;
    min-width: 335px;
    min-height: 190px;
    @media (max-width: $md) {
      padding-top: 60px;
    }
    @media (max-width: $sm) {
      text-align: center;
      padding-top: 100px;
    }
    .main-title {
      font-size: 5rem;
      @media (max-width: $md) {
        font-size: 2.2rem;
      }
     }
    .sub-title {
      font-size: 2rem;
      @media (max-width: $md) {
        font-size: 1rem;
      }
    }
  }

  h2 {
    z-index: 0;
  }

  p {
    letter-spacing: 1px;
    z-index: 0;
  }

  .bg-video {
    object-fit: cover;
    z-index: -1;
  }

  .bg-img {
    object-fit: cover;
    z-index: -1;
  }

  .progress-bar {
    z-index: 0;
    height: 5px;
    width: 180px;

    .bar {
      width: 30%;
      background-color: #fff;

      .bar-filled {
        z-index: 1;
        background-color: #27a1d8;
      }
    }
  }
  .zoom-in {
    animation: zoom-in 10s ease-in-out forwards infinite;
  }

  @keyframes zoom-in {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(1.3);
    }
  }
}
</style>
